module.exports = require('./helpers/bundle-url').getBundleURL('hstjT') + "sms_warmline_thumbnail.4552537a.webp";